import React from 'react';
import PropTypes from 'prop-types';

import ItemGroup from './ItemGroup';

export const RadioContext = React.createContext({
  checkedIndex: null,
  check: (index) => {},
});

export default class ItemRadioGroup extends React.Component {
  static getDerivedStateFromProps(props, state) {
    return {
      ...state,
      checkedIndex: props.checkedIndex,
    };
  }

  state = {
    checkedIndex: null,
    check: null,
  };

  constructor(props) {
    super(props);

    this.state.check = this.checkItem;
  }

  render() {
    const { onChange, ...props } = this.props;

    return (
      <RadioContext.Provider value={this.state}>
        <ItemGroup {...props} />
      </RadioContext.Provider>
    );
  }

  checkItem = (checkedIndex) => this.props.onChange(checkedIndex);
}

ItemRadioGroup.propTypes = {
  ...ItemGroup.propTypes,
  onChange: PropTypes.func,
  checkedIndex: PropTypes.any,
};

ItemRadioGroup.defaultProps = {
  checkedIndex: null,
  onChange: (checkedIndex) => {},
};
